/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import { TYPES_ROLES } from '../../../shared/roles.types';

export default [
  {
    url: '/admin/products',
    name: 'Inventario',
    slug: 'products',
    icon: ['fas', 'utensils'],
    roles: []
  },
  {
    url: '/admin/cartes',
    name: 'Cartas',
    slug: 'products',
    icon: ['fas', 'file-alt'],
    roles: []
  },
  {
    url: '/admin/menus',
    name: 'Menús',
    slug: 'products',
    icon: ['fas', 'file-alt'],
    roles: []
  },
  {
    url: '/admin/restaurant',
    name: 'Mi establecimiento',
    slug: 'restaurant',
    icon: ['fas', 'store-alt'],
    roles: []
  },
  {
    url: '/admin/tickets',
    name: 'Mis comandas',
    slug: 'tickets',
    icon: ['fas', 'receipt'],
    roles: []
  },
  {
    url: '/admin/invoices',
    name: 'Mis facturas',
    slug: 'invoices',
    icon: ['fas', 'file-invoice'],
    roles: []
  },
  {
    url: '/admin/sales',
    name: 'Ofertas',
    slug: 'sales',
    icon: ['fas', 'receipt'],
    roles: []
  },
  {
    url: '/admin/coupons',
    name: 'Cupones',
    slug: 'coupons',
    icon: ['fas', 'receipt'],
    roles: []
  },
  {
    url: '/admin/pop-ups',
    name: 'Pop-ups',
    slug: 'pop-ups',
    icon: ['fas', 'images'],
    roles: [TYPES_ROLES.SUPERADMIN]
  },
  /*{
    url: '/admin/pop-ups-restaurant',
    name: 'Pop-ups restaurante',
    slug: 'pop-ups-restaurant',
    icon: ['fas', 'receipt'],
    roles: []
  },*/
  {
    url: '/admin/generic-banner',
    name: 'Banners Genéricos',
    slug: 'genBanner',
    icon: ['fas', 'file-image'],
    roles: [TYPES_ROLES.SUPERADMIN]
  },
  {
    url: '/admin/restaurant-banner',
    name: 'Banners Restaurante',
    slug: 'ResBanner',
    icon: ['fas', 'file-image'],
    roles: []
  }

];
